<div class="legacy-dialog-body" mat-dialog-content>
	<div class="legacy-dialog-header">
		<div >
			<span class="legacy-dialog-header_span">FAQ</span>
		</div>
	</div>
	<br>
	<ul>
		<li  translate>login-legacy.Do-hav <span class="legacy_faq_text" translate>login-legacy.ques-To</span><span>?</span></li>
		<li ><span translate>login-legacy.stu-Get-your-ans &nbsp;</span>
		<a class="legacy_faq_text" href="mailto:ebusiness.support@arcelormittal.com">ebusiness.support@arcelormittal.com</a></li>
		<br>
		<li  translate>login-legacy.stu-Our-customer</li>
		<li  translate>login-legacy.stu-guide-stu</li>
		<li  translate>login-legacy.stu-usrmanual-stu-1<span class="legacy_faq_text"> user manuals</span>login-legacy.stu-usrmanual-stu-2</li>
		<br>
		<li  translate>login-legacy.stu-interested-partner</li>
		<li  translate>login-legacy.stu-learn-offer &nbsp;<a  href="https://www.youtube.com/watch?v=DD3hdL41X1k" target="_blank"><span>Discover SteelUser (youtube.com)</span></a></li>
		<br>
		<li  translate>login-legacy.stu-hearing-for</li>
</ul>
	</div>
